import { buttonVariablesLight } from "./button.js"
import { dropdownVariablesLight } from "./dropdown.js"
import { datepickerVariablesLight } from "./datepicker.js"
import { inputVariablesLight } from "./input.js"
import { textButtonVariablesLight } from "./text-button.js"
import { tableVariablesLight } from "./table.js"
import { actionVariablesLight } from "./actions.js"
import {dropdownInputVariablesLight} from './dropdown-input.js'
import { accordionVariablesLight } from "./accordion.js"
import {errorLabelVariablesLight} from './error-label.js'
import { checkboxVariablesLight } from "./checkbox.js"

export const lightTheme = {
  ...inputVariablesLight,
  ...tableVariablesLight,
  ...actionVariablesLight,
  ...buttonVariablesLight,
  ...dropdownVariablesLight,
  ...datepickerVariablesLight,
  ...textButtonVariablesLight,
  ...dropdownInputVariablesLight,
  ...errorLabelVariablesLight,
  ...accordionVariablesLight,
  ...checkboxVariablesLight
}

export const darkTheme = {}
